import { create } from "zustand";

interface TokenRefreshLoadingStore {
  isTokenRefreshLoading: boolean;
  setIsTokenRefreshLoading: (isRefreshing: boolean) => void;
}

export const useTokenRefreshLoadingStore = create<TokenRefreshLoadingStore>()(
  (set) => ({
    // Initial navigation states
    isTokenRefreshLoading: false,

    setIsTokenRefreshLoading: (isRefreshing) =>
      set({ isTokenRefreshLoading: isRefreshing })
  })
);
